"use client";
import React, { useState } from "react";
import { cx } from "class-variance-authority";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "../../../../app/globals.css";

export const dynamic = "force-dynamic";

export const GameFaqs = ({ content }) => {
    const [isOpen, setIsOpen] = useState(0);
    const faqShadow = {
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
    };

    const renderers = {
        a: ({ href, children }) => (
            <a href={href} className="custom-link">
                {children}
            </a>
        ),
    };

    return (
        <>
            <div className="container px-4 mx-auto my-20 mt-16 md:px-24 lg:px-24 xl:px-0 ">
                {content?.map((item, ind) => (
                    <div className="my-4" key={item?.id || ind}>
                        <div
                            style={faqShadow}
                            onClick={() =>
                                setIsOpen(item?.id === isOpen ? 0 : item?.id)
                            }
                            className="rounded-2xl w-full md:max-w-7xl md:mx-auto bg-white"
                        >
                            <div className="flex items-center justify-between p-4 text-base font-semibold cursor-pointer">
                                <h3>{item?.question}</h3>
                                {isOpen === item?.id ? " - " : " + "}
                            </div>
                        </div>
                        <div
                            className={cx(
                                isOpen === item?.id ? "h-auto" : "hidden h-0",
                                "w-full md:max-w-7xl md:mx-auto p-4 transition-[height] ease-in-out duration-500"
                            )}
                        >
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={renderers}
                            >
                                {item?.answer}
                            </ReactMarkdown>

                            {item?.keyPoints && (
                                <span>
                                    {item?.keyPoints?.map((points, index) => {
                                        return (
                                            <li
                                                key={index}
                                                className="list-disc"
                                            >
                                                <span>{points?.point}</span>
                                                <br />
                                            </li>
                                        );
                                    })}
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};
